/**
 * @description 
 * -columnKey: object name as given by services
 * -format: S(string / default), N(Currency), I (Long), 
 *          D(Date trunced), T(Timestamp)
 * -alternativeKeys: key used when columnKey is null
 * -actions: JSONArray of action buttons per row
 */
export class ColumnSetting {
    columnKey: string;
    formatDefs?: any;
    alternativeKeys?: string[];
    actions?: any;
    hasOrder?: boolean;
    sortOrder?: number;
}
export class ColumnMap {
    columnKey: string;
    private _formatDefs: any;
    alternativeKeys?: string[];
    actions?: any;
    hasOrder?: boolean;
    sortOrder?: number;
    constructor(settings) {
        this.columnKey = settings.columnKey;
        this.formatDefs = settings.formatDefs;
        this.alternativeKeys = settings.alternativeKeys;
        this.actions = settings.actions;
        this.hasOrder = settings.hasOrder;
        this.sortOrder = settings.sortOrder;
    }
    set formatDefs(setting: any) {
        this._formatDefs = setting ? setting : {format: "S", lkpTable: null, lkpCol: null};
    }
    get formatDefs() {
        return this._formatDefs;
    }
    access = function (object: any) {
        if (object[this.columnKey] || !this.alternativeKeys) {
            return this.columnKey;
        }
        for (let key of this.alternativeKeys) {
            if (object[key]) {
                return key;
            }
        }
        return this.columnKey;
    }
}